
import { Mail, Truck, Shield } from "lucide-react"
import { LucideIcon } from "lucide-react"

export interface DeliveryOption {
  id: string
  title: string
  description: string
  price: number
  icon: LucideIcon
  priceId: string
}

export const deliveryOptions: DeliveryOption[] = [
  {
    id: "email",
    title: "Email Delivery",
    description: "Instant delivery via email",
    price: 5,
    icon: Mail,
    priceId: "price_1QpHMnLBB8IUFcuXIQuq9OcT"
  },
  {
    id: "standard",
    title: "Standard Mail",
    description: "Printed on official letterhead",
    price: 10,
    icon: Truck,
    priceId: "price_1QpHOeLBB8IUFcuXjxC6n0Dh"
  },
  {
    id: "certified",
    title: "Certified Mail",
    description: "Tracked delivery with signature",
    price: 15,
    icon: Shield,
    priceId: "price_1QpHPvLBB8IUFcuX2LJm4Y37"
  }
]
